module.exports = __webpack_public_path__ + "img/section5_img2_4.5ded9ddd.svg";